import { Directive, Injectable } from '@angular/core';
import { MetabaseApiService, MetabaseCardCollection } from './metabase-report-api.service';
import { ApiService, IApiOption } from '@red/api';
import { Mixin } from 'ts-mixer';
import { IQuerySearch } from '@shared/data-access/interfaces';
import { Observable, map } from 'rxjs';
import { PaginationAdapter } from '@red/data-access';
import { ReportCard } from '@shared/components/report-manager';
import { ExceljsApiService, ExceljsCardCollection } from './exceljs-report-api.service';

@Directive()
abstract class AgentReportMetabaseApiService extends MetabaseApiService {
  collection: MetabaseCardCollection = 'agent_reports';
}

@Directive()
abstract class AgentReportExceljsApiService extends ExceljsApiService {
  collectionEndpoint = ExceljsCardCollection.AgentReport;
}
@Directive()
abstract class AgentReportCardApiService {
  static REPORT_CARD_POINT = 'hrm/hr/reports';
  constructor(protected apiService: ApiService) {}

  findReportCards(query: IQuerySearch = {}, option?: IApiOption): Observable<PaginationAdapter<ReportCard>> {
    return this.apiService.get(AgentReportCardApiService.REPORT_CARD_POINT, query, option).pipe(map(data => new PaginationAdapter(ReportCard, data)));
  }
}

@Injectable({
  providedIn: 'root',
})
export class AgentReportApiService extends Mixin(AgentReportCardApiService, AgentReportMetabaseApiService, AgentReportExceljsApiService) {}
